import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'coachingTypePipe',
})
export class CoachingTypePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    switch (value) {
      case 'IN_PERSON_ESCALATION':
        return 'In-Person';

      case 'SELF':
        return 'Self';

      default:
        return value;
    }
  }
}
